import { render, staticRenderFns } from "./Gyakorlat.vue?vue&type=template&id=51889878&lang=html&"
import script from "./Gyakorlat.vue?vue&type=script&lang=js&"
export * from "./Gyakorlat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports